var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg2White = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "75px",
    viewBox: "0 0 87 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7,70.5765595 L29.7,73.0765595 C29.7,73.6765595 30.2,74.0765595 30.7,74.0765595 L57.2,74.0765595 C57.8,74.0765595 58.2,73.5765595 58.2,72.9765595 L58.2,70.3765595 C73.1,65.4765595 84.3,53.3765595 86.8,38.5765595 L86.8,38.4765595 L86.8,38.3765595 C86.8,37.7765595 86.3,37.2765595 85.7,37.2765595 L1.1,37.2765595 C0.5,37.2765595 0,37.7765595 0,38.3765595 L0.1,38.8765595 C3,53.6765595 14.5,65.8765595 29.7,70.5765595 M58.4,1.07655953 C58.1,1.57655953 49.9,13.3765595 58.6,22.8765595 C62.6,27.2765595 62.2,31.0765595 61.1,33.6765595 L66.7,33.6765595 C67.8,29.8765595 67.4,24.9765595 62.8,20.0765595 C56.4,13.0765595 62.9,3.57655953 63,3.47655953 C63.8,2.37655953 63.4,0.976559531 62.1,0.376559531 C60.8,-0.323440469 59.2,-0.0234404694 58.4,1.07655953 M44.3,33.6765595 L49.9,33.6765595 C51,29.8765595 50.6,24.9765595 46,20.0765595 C39.6,13.0765595 46.1,3.57655953 46.2,3.47655953 C47,2.37655953 46.6,0.976559531 45.3,0.376559531 C44,-0.223440469 42.4,0.0765595306 41.6,1.17655953 C41.2,1.67655953 33.1,13.4765595 41.8,22.9765595 C45.8,27.2765595 45.4,31.0765595 44.3,33.6765595 M24.7,1.07655953 C24.3,1.57655953 16.2,13.3765595 24.9,22.8765595 C28.9,27.2765595 28.5,31.0765595 27.4,33.6765595 L33,33.6765595 C34.1,29.8765595 33.7,24.9765595 29.1,20.0765595 C22.7,13.0765595 29.2,3.57655953 29.3,3.47655953 C30.1,2.37655953 29.7,0.976559531 28.4,0.376559531 C27.2,-0.323440469 25.5,-0.0234404694 24.7,1.07655953",
    id: "Shape-Copy-3",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg2White);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/2_white.e1c28ddae236c820e9cbf5137b306683.svg";